import {
  Dispatch,
  SetStateAction,
  useState
} from "react";

export interface InnFormValues {
  inn: string;
}

interface IUseInnFormReturn {
  form: InnFormValues;
  inn: string;
  setInn: (value: string) => void;
  handleChange: (key: keyof InnFormValues, value: string) => void;
  handleInnChange: (text: string) => void;
  resetForm: () => void;
  hasNoValues: boolean;
  setForm: Dispatch<SetStateAction<InnFormValues>>;
}

const initialValues: InnFormValues = { inn: "" };

const useInnForm = (): IUseInnFormReturn => {
  const [form, setForm] = useState<InnFormValues>(initialValues);

  const handleChange = (key: keyof InnFormValues, value: string): void => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleInnChange = (text: string): void => handleChange("inn", text);

  const setInn = (value: string): void => {
    setForm((prev) => ({ ...prev, inn: value }));
  };

  const resetForm = (): void => setForm(initialValues);

  const hasNoValues: boolean = !form.inn;

  return {
    form,
    inn: form.inn,
    setInn,
    handleChange,
    handleInnChange,
    resetForm,
    hasNoValues,
    setForm
  };
};

export default useInnForm;